import React from 'react';
import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';
import useCompany from 'gatsby-theme-core/src/hooks/use-company';
import Content from '../../content';
import Column from '../../column';

const Company = ({
  columnWidth,
  align,
  justify,
  order,
  title,
  planRouteButton = false,
  className,
  offset,
}) => {
  const {
    name,
    street,
    houseNumber,
    postcode,
    city,
    tel,
    tel2,
    email,
    kvk,
    btw,
    iban,
  } = useCompany();

  return (
    <Column
      className={className}
      columnWidth={columnWidth}
      align={align}
      justify={justify}
      order={order}
      offset={offset}
    >
      <Content textAlign={justify}>
        {title && <h1>{title}</h1>}

        <Grid>
          <address>
            {`${street} ${houseNumber}`}
            <br />
            {`${postcode} ${city}`}
          </address>

          <table>
            <tbody>
              {tel && (
                <tr>
                  <td>T:</td>
                  <td><a href={`tel:${tel}`}>{tel}</a></td>
                </tr>
              )}
              {tel2 && (
                <tr>
                  <td>T:</td>
                  <td><a href={`tel:${tel2}`}>{tel2}</a></td>
                </tr>
              )}
              {email && (
                <tr>
                  <td>E:</td>
                  <td><a href={`mailto:${email}`}>{email}</a></td>
                </tr>
              )}
              {kvk && (
                <tr>
                  <td>KvK:</td>
                  <td>{kvk}</td>
                </tr>
              )}
              {btw && (
                <tr>
                  <td>BTW:</td>
                  <td>{btw}</td>
                </tr>
              )}
              {iban && (
                <tr>
                  <td>IBAN:</td>
                  <td>{iban}</td>
                </tr>
              )}
            </tbody>
          </table>
        </Grid>

        {planRouteButton && (
          <StyledButton
            primary
            href={`https://www.google.nl/maps/dir//${encodeURIComponent(`${name},${street} ${houseNumber},${city}`)}`}
          >
            Plan route
          </StyledButton>
        )}
      </Content>

    </Column>
  );
};

const StyledButton = styled(Button)`
  margin-top: 1rem;
  min-width: 10rem;
`;

const Grid = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: 1rem;
  grid-template-columns: 1fr;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }

  address {
    line-height: 180%;
  }

  table {
    line-height: 150%;

    td:first-child {
      color: ${({ theme }) => theme.primaryColor};
      font-weight: 600;
    }

    td:last-child {

      a {
        color: ${({ theme }) => theme.grayColor};
        font-weight: 400;
      }
    }
  }
`;

export default Company;
